import { GetterTree } from 'vuex';
import { StateInterface } from '@/store';
import { LoginStateInterface } from './state';

const getters: GetterTree<LoginStateInterface, StateInterface> = {
  authenticated(state): boolean {
    return state.authenticated;
  },
  email(state): string {
    return state.email;
  },
  role(state): string {
    return state.role;
  },
  organizationId(state): string {
    return state.organizationId;
  },
  temporaryEmail(state): string {
    return state.temporaryEmail;
  },
};

export default getters;
